import React, {memo, useCallback, useEffect, useRef, useState,} from "react";
import {useTranslation} from "react-i18next";
import {Map} from "ol";
import {PolygonSvg} from "../../../../shared/assets/svgs/PolygonSvg";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import {usePolygonDraw} from "@delivus-daas/react-open-layers";
import {TMarkerProperty} from "../../../../shared/hooks/useMapFunctions";
import {Button} from "../../../../shared/ui";

interface Props<T> {
  map?: Map;
  clusterSource?: VectorSource;
  getSelectedShippings: () => T[];
  onSelectShippings: (shippings: T[]) => void;
  addToSelectedShippings: (feature: Feature, properties: TMarkerProperty<T>) => void;
}

export const DrawPolygonButton = memo(({
                                         map,
                                         clusterSource,
                                         addToSelectedShippings,
                                         getSelectedShippings,
                                         onSelectShippings
                                       }: Props<any>) => {
  const {t} = useTranslation(["shipping"]);
  const [isVisiblePolygon, setVisiblePolygon] = useState(false);
  const drawSource = useRef<VectorSource>();
  const drawnPolygonsRef = useRef<Feature[]>([]);
  
  useEffect(() => {
    drawSource.current = undefined;
    drawnPolygonsRef.current = [];
  }, [isVisiblePolygon]);
  
  const handleDrawEnd = useCallback((event: any) => {
    drawnPolygonsRef.current.push(event.feature);
    const extents = event.feature.getGeometry()
                         .getExtent();
    if (clusterSource) {
      const features = clusterSource.getFeaturesInExtent(extents);
      features.forEach((f: Feature) => {
        const properties = f.getProperties() as TMarkerProperty;
        if (properties.shipping && !properties.highlighted) {
          addToSelectedShippings(f, properties);
        }
      });
      const shippings = getSelectedShippings();
      onSelectShippings(shippings);
    }
  }, [addToSelectedShippings, getSelectedShippings, onSelectShippings, clusterSource]);
  
  usePolygonDraw({
    map, onSourceCreated: (source) => (drawSource.current = source), onDrawEnd: handleDrawEnd, visible: isVisiblePolygon
  });
  
  return (<Button
    size={"sm"}
    variant={"primary"}
    className={"button " + isVisiblePolygon}
    onClick={() => setVisiblePolygon((prev) => !prev)}>
    <PolygonSvg className={isVisiblePolygon ? "text-white" : "text-black/85"} />
    {t("polygon draw")}
  </Button>);
});
